module.exports = __webpack_public_path__ + "img/symbol_1.ce00ce1e.png";